import clsx from 'clsx';
import {
  CHATBOT_CHAT_MSJ_FROM_BOT,
  CHATBOT_CHAT_MSJ_FROM_CLIENT,
  CHATBOT_MODE_CHATBOT,
 } from '../utils/constants.js';
import AudioPlayerChatbot from './audioPlayerChatbot.jsx';
import MessageLikesChatbot from './messageLikesChatbot.jsx';
import historyBlackBotIcon from '/src/assets/historyBlueBotIcon.svg';
import historyRedBotIcon from '/src/assets/historyRedBotIcon.svg';

export default function MessageBubbleChatbot({modeChatbot, welcomeNavigationStateChatbot, item, isFirstMessage, isLastMessage, transform }) {
  const { id, from, message, audio } = item;
  return (
    <div
      key={id.toString() + '-' + 'message'}
      className={clsx(
        'bot-utn-styled-message-row',
        { client: from === CHATBOT_CHAT_MSJ_FROM_CLIENT },
        { bot: from === CHATBOT_CHAT_MSJ_FROM_BOT },
        { ['bot-utn-first-message']: isFirstMessage },
        { ['bot-utn-last-message']: isLastMessage }
      )}
    >
      {from === CHATBOT_CHAT_MSJ_FROM_BOT && (
        modeChatbot ?
          <div className='bot-utn-from-icon-container'>
            <img src={historyBlackBotIcon} alt='logo alert'/>
          </div>
        :
          <div className='bot-utn-from-icon-container'>
            <img src={historyRedBotIcon} alt='logo alert'/>
          </div>

      )}
      <div className={clsx({
        'bot-utn-recommender-container-text': welcomeNavigationStateChatbot === 2 && modeChatbot != CHATBOT_MODE_CHATBOT,
        'bot-utn-container-text': modeChatbot === CHATBOT_MODE_CHATBOT
        })}
      >
        {audio ? (
          <AudioPlayerChatbot audioData={audio} from={from} />
        ) : (
          <div
            className='bot-utn-bubble bot-utn-typography-03'
            dangerouslySetInnerHTML={transform(message)}
          />
        )}
        {/*<div className="message-timestamp">{formatTimestamp(timestamp)}</div>*/}
      </div>
      {from === CHATBOT_CHAT_MSJ_FROM_BOT && id > 1 && <MessageLikesChatbot id={id} />}
    </div>
  );
}

function formatTimestamp(timestamp) {
  const date = new Date(timestamp);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}
